import React, { useState, useEffect, useRef } from "react";
import {
  DatabaseOutlined,
  ToolOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";

const StatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const stats = [
    {
      icon: <DatabaseOutlined />,
      number: 260,
      suffix: "+",
      label: "Assets Connected",
      description: "Real-time monitoring across all facilities",
    },
    {
      icon: <ToolOutlined />,
      number: 15,
      suffix: "+",
      label: "Shopfloors Digitized",
      description: "Seamless integration with existing systems",
    },
    {
      icon: <AppstoreOutlined />,
      number: 8,
      suffix: "",
      label: "Industries Served",
      description: "Automotive, Steel, Glass, Agri-processing, Metal, Health Tech, Paper & Electronics",
    },
  ];

  const [counters, setCounters] = useState(stats.map(() => 0));

  // Intersection Observer for scroll trigger
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isVisible) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  // Counter animation
  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000; // 2 seconds
    const steps = 60;
    const stepDuration = duration / steps;

    stats.forEach((stat, index) => {
      let currentStep = 0;
      const increment = stat.number / steps;

      const timer = setInterval(() => {
        currentStep++;
        setCounters((prev) => {
          const newCounters = [...prev];
          newCounters[index] = Math.min(
            Math.ceil(increment * currentStep),
            stat.number
          );
          return newCounters;
        });

        if (currentStep >= steps) {
          clearInterval(timer);
        }
      }, stepDuration);
    });
  }, [isVisible]);

  return (
    <div
      ref={sectionRef}
      className="bg-white dark:bg-gray-900 py-16 px-4 mt-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center border-b-4 border-blue-500 dark:border-blue-400 pb-6"
            >
              <div className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 dark:from-blue-400 dark:to-indigo-400 bg-clip-text text-transparent mb-3">
                {counters[index]}{stat.suffix}
              </div>
              <h3 className="text-xl md:text-2xl font-semibold text-gray-900 dark:text-white mb-2">
                {stat.label}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {stat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default StatsSection;
